export default __webpack_public_path__ + "pin_micro_selected.svg";